import { render, staticRenderFns } from "./ShipmentDocumentView.vue?vue&type=template&id=ac7154e4&scoped=true&"
import script from "./ShipmentDocumentView.vue?vue&type=script&lang=js&"
export * from "./ShipmentDocumentView.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentDocumentView.vue?vue&type=style&index=0&id=ac7154e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac7154e4",
  null
  
)

export default component.exports